// extracted by mini-css-extract-plugin
export default {"wrapper":"Mx-z","button":"Nx-z","alternate":"Ox-z","disabled":"Px-z","paymentWarning":"Qx-z","fadeIn":"Rx-z"};